/*jslint browser: true, fudge: true, long: true */
/*global $, blacksunplc, dialogPolyfill, document, location, navigator, window */

blacksunplc.events.ready(function () {
    "use strict";

    $(".checkbox-group").on("click", function (event) {
        var checkbox = $(this).find("input[type='checkbox']")[0];
        if (checkbox) {
            checkbox.checked = !checkbox.checked;
        }

        $(this).toggleClass("checked", checkbox.checked);
        event.preventDefault();
    });

    $("form").on("submit", function (event) {
        var $form = $(this);
        var hasErrors = false;

        console.log("Submitting form:", $form);

        $form.find(".required").each(function () {
            var $field = $(this);
            var value = $field.val();

            if (this.type === "checkbox") {
                value = $field.closest(".checkboxes").find("input[type='checkbox']:checked").length > 0 ? "checked" : "";
            }

            if (!value || value.trim() === "") {
                var $errorMsg = $field.next(".error-message");

                if(this.type === "checkbox") {
                    $errorMsg = $field.closest(".checkboxes").find(".error-message");
                }

                if ($errorMsg.length === 0) {
                    if(this.type === "checkbox") {
                        if($(this).hasClass("terms")) {
                            $field.closest(".checkboxes").append("<span class='error-message'>You must agree to the terms</span>");
                        } else {
                            $field.closest(".checkboxes").append("<span class='error-message'>You must select at least one option</span>");
                        }
                    } else {
                        $field.after("<span class='error-message'>This field is required</span>");
                    }
                } else {
                    $errorMsg.show();
                }
                hasErrors = true;
            } else {
                if(this.type === "checkbox") {
                    $field.closest(".checkboxes").find(".error-message").hide();
                } else {
                    $field.next(".error-message").hide();
                }
            }
        });

        if (hasErrors) {
            event.preventDefault();
        }
    });
    
});
